module.exports = "/_next/static/images/speaker-62e2f5f17fac226a3b5ee8584ce5ab31.svg";